import { USER_ROLE, USER_ROLE_LABELS } from '@/constants';

export const selectToken = (state) => state.auth?.token;

export const selectIsAuthenticated = (state) => Boolean(state.auth?.token);

export const selectCurrentUser = (state) => state.auth?.user || null;

export const selectUserValidated = (state) => Boolean(state.auth?.user);

export const selectPortfolioId = (state) => state.auth?.user?.portfolioId || undefined;

export const selectPortfolioName = (state) => state.auth?.user?.portfolioName || undefined;

export const selectUserEmail = (state) => state.auth?.user?.email || undefined;

export const selectUserPicture = (state) => state.auth?.user?.picture || undefined;

export const selectUsername = (state) => {
  const user = state.auth?.user;
  if (!user) return undefined;
  const first = typeof user.firstName === 'string' ? user.firstName.trim() : '';
  const last = typeof user.lastName === 'string' ? user.lastName.trim() : '';
  const full = [first, last].filter(Boolean).join(' ');
  return full || user.name || undefined;
};

export const selectUserRoles = (state) => state.auth?.user?.roles || [];

export const selectUserRole = (state) => {
  const roles = state.auth?.user?.roles || [];
  const roleName = roles[0];
  return roleName ? USER_ROLE_LABELS[roleName] || roleName : undefined;
};

export const selectIsGlobalAdmin = (state) =>
  (state.auth?.user?.roles || []).includes(USER_ROLE.GLOBAL_ADMIN);

// An "admin" for permission purposes is anyone who can manage a portfolio:
// an administrator or a global administrator (global admin is a superset).
export const selectIsAdmin = (state) => {
  const roles = state.auth?.user?.roles || [];
  return roles.includes(USER_ROLE.ADMIN) || roles.includes(USER_ROLE.GLOBAL_ADMIN);
};

export const selectUseBrowserTimeZone = (state) => state.auth?.user?.useBrowserTimeZone ?? true;

export const selectUserTimeZone = (state) => state.auth?.user?.timeZone || null;
